import { render, staticRenderFns } from "./ArticleItem.vue?vue&type=template&id=17069962&scoped=true"
import script from "./ArticleItem.vue?vue&type=script&lang=js"
export * from "./ArticleItem.vue?vue&type=script&lang=js"
import style0 from "./ArticleItem.vue?vue&type=style&index=0&id=17069962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17069962",
  null
  
)

export default component.exports